<template>
  <div class="mt-8">
    <div class="intro-y">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  components: {},

  data() {
    return {
      tabs: [
        {
          key: 1,
          label: this.$t('text.allCustomers'),
        },
      ],
      currentTab: 1,
      tabFilters: [],
    };
  },
};
</script>
